import * as React from 'react'

import {
  CurrentContractFragment,
  PayrollBundlePolicyPageDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import type PolicyPeriod from 'modules/payroll_bundle/store/models/PolicyPeriod'

interface PolicyPageData {
  policyCurrentContracts: CurrentContractFragment[]
  loading: boolean
}

const initialState: PolicyPageData = {
  policyCurrentContracts: [],
  loading: true,
}

const policyPageContext = React.createContext<PolicyPageData | null>(null)

const PolicyPageProvider = policyPageContext.Provider

interface Props {
  policyPeriod: PolicyPeriod | null | undefined
}

export const PolicyPageContextProvider = ({
  policyPeriod,
  children,
}: React.PropsWithChildren<Props>) => {
  const { data: pageData, loading } = useQuery(PayrollBundlePolicyPageDocument, {
    variables: {
      currentOn: policyPeriod?.attributes.ends_on,
    },
    skip: !policyPeriod,
  })

  const policyCurrentContracts = pageData?.contracts.contractVersions || []

  const value = {
    policyCurrentContracts,
    loading,
  }

  return <PolicyPageProvider value={value}>{children}</PolicyPageProvider>
}

export const usePolicyPage = () => {
  const page = React.useContext(policyPageContext)

  if (!page) {
    throw new Error('usePolicyPageContext hook must be used within a PolicyPageProvider provider')
  }

  return page
}
